export const filterSelectableSuggestions = (
    incomingSuggestedAttributes,
    categoryAttributes,
) => {
    const selectableSuggestions = [];
    incomingSuggestedAttributes.forEach((sa) => {
        const categoryAttribute = categoryAttributes.find(
            (a) => a.id === sa.id,
        );
        if (categoryAttribute) {
            const suggestedAttribute = {
                id: sa.id,
                values: [],
                autoSelect: sa.autoSelect,
            };
            sa.values.forEach((v) => {
                const isSelectableSuggestion = categoryAttribute.options.some(
                    (o) => o.value === v,
                );
                const isMaxReached =
                    suggestedAttribute.values.length >=
                    categoryAttribute.maxNumberOfValues;
                if (isSelectableSuggestion && !isMaxReached) {
                    suggestedAttribute.values.push(v);
                }
            });
            selectableSuggestions.push(suggestedAttribute);
        }
    });
    return selectableSuggestions;
};
